<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { fade } from 'svelte/transition'

	import XCloseButton from '$lib/components/XCloseButton.svelte'

	const dispatch = createEventDispatcher()

	export let open = false

	const handleKeydown = (event: any) => {
		if (event.key === 'Escape') dispatch('close')
	}
</script>

<svelte:window on:keydown={handleKeydown} />

{#if open}
	<div in:fade|global={{ duration: 150 }} class="fixed z-50 inset-0 bg-black/60 ">
		<button
			class="z-50 fixed inset-0 w-screen h-screen flex items-center justify-center p-2 sm:p-8 lg:p-0"
			on:click|stopPropagation={() => dispatch('close')}
		>
			<div
				class="absolute h-fit w-fit bg-white dark:bg-light my-auto sm overflow-scroll px-4 mx-auto rounded-lg shadow-xl z-50 "
			>
				<div
					class="p-4 flex z-50 justify-center items-start sticky top-0 w-full bg-white dark:bg-light"
				>
					<div class="font-bold text-2xl pr-6 text-center">
						<slot name="title" />
					</div>
					<div class="absolute right-0 ">
						<XCloseButton on:click={() => dispatch('close')} />
					</div>
				</div>
				<div>
					<slot name="body" />
				</div>
				<div class="block sm:hidden">
					<div class="w-full bottom-0 py-4 pb-10 px-2 left-0 bg-white dark:bg-slate-800">
						<slot name="buttons" />
					</div>
				</div>
				<div class="hidden sm:block">
					<div class="w-full sticky bottom-0 py-4 bg-white dark:bg-slate-800">
						<slot name="buttons" />
					</div>
				</div>
			</div>
		</button>
	</div>
{/if}
